import { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSpring, animated } from 'react-spring';
import { useHistory } from 'react-router-dom';
import { setUnit } from '../../Session';
import { useWidth } from '../../CustomHooks';
import { selectClassroom } from '../../Classrooms';
import { fixedEncodeURIComponent, getLetterGradeFromNumberGrade } from '../../GlobalFunctions';
import { RootState } from '../../ApplicationState';
import CompletionButton from './CompletionButton';
import styles from './CompletionBreakdown.module.scss';

interface Props {
  title: string;
  id: string;
  completeModules: number;
  totalModules: number;
  barColor: string;
  isShouldAnimate: boolean;
}

const CompletionRow = ({ title, totalModules, completeModules, barColor, isShouldAnimate, id }: Props): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const barWidth = useWidth(ref);
  const history = useHistory();
  const dispatch = useDispatch();
  const classroom = useSelector((state: RootState) => {
    const selectedClassroom = selectClassroom(state);
    return selectedClassroom;
  });
  const progressSpringProps = useSpring({
    from: { width: 0 },
    to: {
      width: barWidth !== null && barWidth !== 0 && isShouldAnimate ? barWidth * (completeModules / totalModules) : 0,
    },
    delay: 200,
  });
  const goToUnit = () => {
    if (classroom.grade > 5) {
      history.push(`/lessonPlan/${id}/${classroom.language}/${classroom.grade}`);
      return;
    }
    dispatch(setUnit(id));
    history.push(
      `/${fixedEncodeURIComponent(classroom.className)}/lessonPlan/${id}-${getLetterGradeFromNumberGrade(
        classroom.grade,
      )}`,
    );
  };

  const getButtonText = () => {
    if (completeModules / totalModules === 0) return 'Explore';
    if (completeModules / totalModules === 1) return 'Complete';
    return 'Resume';
  };

  return (
    <div className={styles.barRow}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.incompleteBar} ref={ref}>
        <animated.div
          className={styles.completeBar}
          style={{
            backgroundColor: barColor,
            ...progressSpringProps,
            borderTopRightRadius: completeModules / totalModules === 1 ? '4px' : 0,
            borderBottomRightRadius: completeModules / totalModules === 1 ? '4px' : 0,
          }}
        >
          {barWidth != null &&
            (barWidth * completeModules) / totalModules > 30 &&
            `${Math.floor((completeModules / totalModules) * 100)}%`}
        </animated.div>
      </div>
      <div className={styles.expandContainer}>
        <CompletionButton handleClick={goToUnit} buttonText={getButtonText()} />
      </div>
    </div>
  );
};

export default CompletionRow;
